import Button from '@mui/material/Button';
import { makeThemedStyles } from '@qpr/components/utils';
import React from 'react';

const useStylesForTabs = makeThemedStyles('ToggleButtonGroup.IconButton', () => ({
  IconButton: {},
  disabled: {}
}));

type PropType = React.ComponentProps<typeof Button>;

export const IconButton: React.FunctionComponent<PropType> = (props: PropType) => {
  const styles = useStylesForTabs();
  return (
    <Button
      {...props}
      className={styles.IconButton}
      classes={{
        root: styles.IconButton,
        contained: styles.disabled
      }}
    >
      {props.children}
    </Button>
  );
};
export default IconButton;
